import { render, staticRenderFns } from "./SafetyUpdate.vue?vue&type=template&id=e8d0fbf4&scoped=true"
import script from "./SafetyUpdate.vue?vue&type=script&lang=js"
export * from "./SafetyUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d0fbf4",
  null
  
)

export default component.exports